/**
 * convert a string into a slug
 * Code taken from https://gist.github.com/codeguy/6684588#gistcomment-2690429
 */
export function slugify(input, separator = "-") {
  let str = input.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase(); // convert all to lowercase.

  // remove accents, swap ñ for n, etc
  const from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
  const to = "aaaaaaeeeeiiiioooouuuunc------";

  for (let i = 0, l = from.length; i < l; i += 1) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes
    .replace(/^-+/, "") // trim - from start of text
    .replace(/-+$/, "") // trim - from end of text
    .replace(/-/g, separator); // replace separator with desired character

  return str;
}

export default {
  slugify,
};
